export const VALIDATE_VOE_TOKEN = gql`
  query ValidateVoEToken($voeId: String!, $token: String!) {
    validateVoEToken(voeId: $voeId, token: $token) {
      valid
      allowedDomain
      lockedByOther
      alreadySubmitted
      error
    }
  }
`

export const REQUEST_VOE_OTP = gql`
  mutation RequestVoEOtp(
    $voeId: String!
    $token: String!
    $firstName: String!
    $lastName: String!
    $email: String!
  ) {
    requestVoEOtp(
      voeId: $voeId
      token: $token
      firstName: $firstName
      lastName: $lastName
      email: $email
    ) {
      success
      error
    }
  }
`

export const VERIFY_VOE_OTP = gql`
  mutation VerifyVoEOtp(
    $voeId: String!
    $token: String!
    $email: String!
    $code: String!
  ) {
    verifyVoEOtp(voeId: $voeId, token: $token, email: $email, code: $code) {
      sessionToken
      error
    }
  }
`

export const GET_PUBLIC_VOE_RESPONSE_DATA = gql`
  query GetPublicVoEResponseData($voeId: String!, $sessionToken: String!) {
    publicVoEResponseData(voeId: $voeId, sessionToken: $sessionToken) {
      voeId
      companyId
      status
      type
      driverName
      dob
      companyName
      contactName
      email
      phoneNumber
      faxNumber
      dotNumber
      companyAddress {
        street
        city
        state
      }
      requestContent {
        voeRequestContentId
        startDate
        endDate
        positionHeld
        reasonForLeaving
        trailerTypes
        isDriverTerminated
        isDriverSubjectToFMCSRs
        isJobDesignatedAsSafetySensitiveFunctionUnderDOT
      }
      responseContent {
        voeResponseContentId
        startDate
        endDate
        positionHeld
        reasonForLeaving
        trailerTypes
        isDriverTerminated
        isDriverSubjectToFMCSRs
        isJobDesignatedAsSafetySensitiveFunctionUnderDOT
        eligibleForRehire
      }
      applicant {
        firstName
        middleName
        lastName
      }
      accidents {
        accidentId
        accidentDate
        city
        state
        description
        isPreventable
        isCommercialMotorVehicleInvolved
        involvedFatalities
        involvedInjuries
      }
    }
  }
`

export const SUBMIT_VOE_RESPONSE_V2 = gql`
  mutation SubmitVoEResponseV2(
    $voeId: String!
    $sessionToken: String!
    $input: SubmitVoEResponseV2Input!
  ) {
    submitVoEResponseV2(voeId: $voeId, sessionToken: $sessionToken, input: $input)
  }
`
